<template>
  <b-row>
    <b-col cols="12">
      <b-overlay :show="showOverlay" rounded="sm">
        <GccDetail :gccObj="gccDetail">
          <div class="d-flex justify-content-end">
            <b-button
              v-if="gccObj.processlevel === 1"
              @click="onReceivedBtnClicked"
              variant="success"
              class="ml-1"
            >
              รับเรื่อง
            </b-button>
            <b-button
              v-if="gccObj.processlevel === 1"
              @click="onClueBtnClicked"
              variant="primary"
              class="ml-1"
            >
              แจ้งเบาะแส
            </b-button>
            <b-button
              v-if="gccObj.processlevel === 1"
              @click="onSendAckBtnClicked"
              variant="outline-success"
              class="ml-1"
            >
              รับทราบ
            </b-button>
            <b-button
              v-if="gccObj.processlevel === 1"
              @click="onSendBackBtnClicked"
              variant="danger"
              class="ml-1"
            >
              ส่งกลับ
            </b-button>
            <b-button
              @click="onCancelBtnClicked"
              variant="secondary"
              class="ml-1"
            >
              ย้อนกลับ
            </b-button>
          </div>
        </GccDetail>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BButton, BOverlay } from "bootstrap-vue";
import step from "../forms/step.vue";
import GccDetail from "./components/GCCDetail.vue";

import * as gccStore from "@/store/api/gcc/index.js";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BOverlay,
    step,
    GccDetail,
  },
  data() {
    return {
      gccDetail: {
        rootobject: {},
      },
      gccObj: {
        processlevel: null,
      },
      showOverlay: false,
    };
  },
  mounted() {
    this.getGccApi();
    this.getGccByCaseId();
  },
  methods: {
    getGccApi() {
      const _this = this;
      _this.showOverlay = true;
      gccStore
        .getApiById(this.$route.query.id)
        .then((response) => {
          _this.gccDetail = response.data.data;

          // _this.$refs.formData.$data.company.complaintDetail =
          //   "(" +
          //   response.data.data.rootobject.case_code +
          //   ") - " +
          //   response.data.data.rootobject.detail;
          // _this.$refs.formData.$data.deptComplaintCode =
          //   response.data.data.rootobject.case_id;
        })
        .catch((err) => {
          console.log("err", err);
        })
        .then(() => {
          _this.showOverlay = false;
        });
    },
    getGccByCaseId() {
      const _this = this;

      gccStore
        .getByCaseId(this.$route.query.id)
        .then((response) => {
          _this.gccObj = response.data.data;
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    onReceivedBtnClicked() {
      this.openUrl("GCCReceived");
    },
    onClueBtnClicked() {
      this.openUrl("GCCClue");
    },
    onSendAckBtnClicked() {
      this.openUrl("GCCAcknowledge");
    },
    onSendBackBtnClicked() {
      this.openUrl("GCCSendBack");
    },
    onCancelBtnClicked() {
      const routeData = this.$router.resolve({
        name: "GCC",
      });
      window.open(routeData.href, "_self");
    },
    openUrl(componentName) {
      const routeData = this.$router.resolve({
        name: componentName,
        query: { id: this.$route.query.id },
      });
      window.open(routeData.href, "_self");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
